import { epochToTimeDistribution } from './time-distribution.util';
import { fallbackSystemDateFormat } from './format.util';
export function getNotificationMessageParts({ locale, notification, dateFormatFn = fallbackSystemDateFormat, localizeFn, }) {
    var _a;
    if (!notification) {
        return null;
    }
    const periodLabel = notification.payload.endDate ? 'common:from_time_to_time' : 'common:from_time';
    const endDate = notification.payload.endDate ? dateFormatFn(notification.payload.endDate) : undefined;
    const period = localizeFn(periodLabel, { startDate: dateFormatFn(notification.payload.startDate), endDate });
    const body = ((_a = notification.payload.content.find((content) => content.lang === locale)) === null || _a === void 0 ? void 0 : _a.description) || '';
    return { period, body };
}
export function getNotificationSocketTopicRecipients({ tenantId, applicationId, }) {
    return [`${tenantId}:${applicationId}`];
}
export function notificationToTimeDistribution(notification) {
    const epoch = {
        start: new Date(notification.notificationStartDate),
        end: new Date(notification.notificationEndDate),
    };
    return epochToTimeDistribution(epoch);
}
export const addNotification = (notification) => {
    return (prevState) => [...prevState, notification];
};
export const deleteNotification = (notification) => {
    return (prevState) => prevState.filter((stateNotification) => stateNotification.id !== notification.id);
};
export function isPlatformNotificationLegacy(notification) {
    return !!notification.applications;
}
//# sourceMappingURL=notification.util.js.map